<div class="td-wrap">

  <a href="javascript:;" class="td-back" (click)="back()"><i class="fa fa-arrow-left"></i> Kembali ke daftar Muraja'ah</a>

  <!-- hero: who, then the four numbers that matter -->
  <div class="td-card td-hero">
    <div class="vl-loading" *ngIf="loading.murojaah && !mrj"><img src="assets/images/preloaders/3.svg" class="vl-loading-img" alt="Memuat data"></div>
    <div class="td-hero-top">
      <div class="td-photo-wrap">
        <img [src]="(user && user.photoUrl) || 'assets/images/no_avatar.webp'" alt="{{user ? user.nameVw : ''}}" class="td-photo round" [class.vb-click]="user && user.photoUrl" title="Lihat foto"
             (click)="openViewer(user && user.photoUrl)" onerror="this.onerror=null;this.src='assets/images/no_avatar.webp';">
      </div>
      <div class="td-hero-main">
        <div class="td-title-row">
          <h2>{{user ? user.nameVw : (loading.user ? 'Memuat…' : 'Pengguna #' + id)}}</h2>
          <ng-container *ngIf="mrj && mrj.available">
            <span class="vl-pill on" *ngIf="mrj.lancarPct != null"><span class="vl-dot"></span>Aktif muraja'ah</span>
            <span class="vl-pill off" *ngIf="mrj.lancarPct == null"><span class="vl-dot"></span>Tidak aktif 30 hari</span>
          </ng-container>
        </div>
        <p class="td-desc vl-muted" *ngIf="user && user.email">{{user.email}}</p>
        <div class="hd-chips" *ngIf="mrj && mrj.available">
          <span class="td-chip"><i class="fa fa-list"></i> {{formatNumber(mrj.items.length)}} item daftar</span>
          <span class="td-chip green" *ngIf="mrj.streak_days"><i class="fa fa-fire"></i> {{formatNumber(mrj.streak_days)}} hari beruntun</span>
          <span class="td-chip" *ngIf="mrj.plan"><i class="fa fa-calendar"></i> Jadwal: {{mrj.planVw}}</span>
          <span class="td-chip danger" *ngIf="mrj.weak.length"><i class="fa fa-exclamation-circle"></i> {{formatNumber(mrj.weak.length)}} halaman lemah</span>
        </div>
      </div>
      <span class="tl-readonly" title="Halaman ini hanya untuk memantau"><i class="fa fa-eye"></i> Hanya lihat</span>
    </div>

    <div class="td-stats" *ngIf="mrj && mrj.available">
      <div class="td-stat">
        <span class="td-label">Item Daftar</span>
        <span class="td-num">{{formatNumber(mrj.items.length)}}</span>
        <span class="td-kpi-foot">{{formatNumber(mrj.itemsJuz)}} juz &middot; {{formatNumber(mrj.itemsSurah)}} surat &middot; {{formatNumber(mrj.itemsPages)}} halaman</span>
      </div>
      <div class="td-stat">
        <span class="td-label">Putaran Ini Diulang</span>
        <span class="td-num">{{mrj.fresh_pct}}<span class="td-num-of">%</span></span>
        <span class="td-kpi-foot"><span class="tl-bar"><span class="tl-bar-fill" [style.width.%]="mrj.fresh_pct"></span></span>{{formatNumber(mrj.pages_fresh)}}/{{formatNumber(mrj.pages_memorized)}} halaman &middot; {{formatNumber(mrj.juz_memorized)}} juz<ng-container *ngIf="mrj.plan"> &middot; 1 putaran &plusmn;{{formatNumber(mrj.rotation_days)}} hari</ng-container></span>
      </div>
      <div class="td-stat">
        <span class="td-label">Sesi</span>
        <span class="td-num">{{formatNumber(mrj.sessions_total)}}</span>
        <span class="td-kpi-foot">{{formatNumber(mrj.streak_days)}} hari beruntun &middot; {{formatNumber(mrj.pages_reviewed)}} halaman pernah diulang</span>
      </div>
      <div class="td-stat">
        <span class="td-label">Kelancaran 30 Hari</span>
        <span class="td-num" *ngIf="mrj.lancarPct != null">{{mrj.lancarPct}}<span class="td-num-of">%</span></span>
        <span class="td-num td-num-sm" *ngIf="mrj.lancarPct == null">&mdash;</span>
        <span class="td-kpi-foot">{{mrj.lancar_30d}} lancar &middot; {{mrj.tersangkut_30d}} tersangkut &middot; {{mrj.lupa_30d}} lupa</span>
      </div>
    </div>
  </div>

  <div class="td-card td-empty" *ngIf="mrj && !mrj.available">
    <i class="fa fa-database"></i>
    <h3>Data Muraja'ah Belum Tersedia</h3>
    <p>Tabel muraja'ah belum ada di database ini (migrasi API belum dijalankan).</p>
  </div>

  <ng-container *ngIf="mrj && mrj.available">
    <!-- ---------- DAFTAR MURAJA'AH ---------- -->
    <div class="vl-card">
      <div class="td-subbar">
        <b class="mr-head">Daftar Muraja'ah</b>
        <span class="vl-muted vl-small">Juz, Surat, dan Halaman yang dipilih pengguna untuk diulang</span>
      </div>
      <div class="vl-scroll" *ngIf="mrj.items.length">
      <table class="vl-table">
        <thead><tr><th class="vl-num">No</th><th>Judul</th><th>Mode</th><th class="text-center">Diulang</th><th>Terakhir Diulang</th></tr></thead>
        <tbody>
        <tr *ngFor="let it of mrj.items; let i = index" class="vl-row" [class.vl-alt]="i % 2 == 1">
          <th class="vl-num">{{i + 1}}</th>
          <td>
            <div class="mr-item">
              <span class="vl-name">{{it.title}}</span>
              <span class="vl-tag" [ngClass]="'mk-' + it.kind">{{it.kind_label}}</span>
            </div>
          </td>
          <td>{{it.mode_label}} <span class="vl-muted">&middot; {{formatNumber(it.repeat)}}&times;</span></td>
          <td class="text-center"><span class="tl-count">{{formatNumber(it.review_count)}}&times;</span></td>
          <td><span [class.vl-muted]="it.last_reviewed_ago == null" [title]="it.lastReviewedFull">{{it.lastReviewedVw}}</span></td>
        </tr>
        </tbody>
      </table>
      </div>
      <div class="vl-empty" *ngIf="!mrj.items.length">Pengguna belum membuat daftar muraja'ah.</div>
    </div>

    <!-- ---------- PETA MURAJA'AH ---------- -->
    <div class="vl-card">
      <div class="td-subbar">
        <b class="mr-head">Peta Muraja'ah</b>
        <span class="vl-muted vl-small">per juz, dalam satu putaran</span>
        <div class="vl-spacer"></div>
        <span class="td-legend"><i class="complete"></i> Sudah</span>
        <span class="td-legend"><i class="partial"></i> Proses</span>
        <span class="td-legend"><i class="due"></i> Belum</span>
        <span class="td-legend"><i class="none"></i> Tidak dihafal</span>
      </div>
      <div class="mr-juz">
        <span *ngFor="let j of mrj.juz" class="mr-juz-cell" [ngClass]="j.state" [title]="j.title">
          {{j.juz}}<i class="mr-weak" *ngIf="j.weak_pages"></i>
        </span>
      </div>
    </div>

    <!-- ---------- HALAMAN LEMAH ---------- -->
    <div class="vl-card">
      <div class="td-subbar">
        <b class="mr-head">Halaman Lemah</b>
        <span class="vl-muted vl-small">penilaian terakhir tersangkut atau lupa</span>
      </div>
      <div class="vl-scroll" *ngIf="mrj.weak.length">
      <table class="vl-table">
        <thead><tr><th class="vl-num">Halaman</th><th>Juz</th><th>Nilai Terakhir</th><th class="text-center">Ayat Tersangkut</th><th class="text-center">Pernah Lupa</th><th class="text-center">Diulang</th><th>Terakhir</th></tr></thead>
        <tbody>
        <tr *ngFor="let w of mrj.weak; let i = index" class="vl-row" [class.vl-alt]="i % 2 == 1">
          <th class="vl-num">{{w.page}}</th>
          <td>Juz {{w.juz}}</td>
          <td><span class="vl-tag" [class.grade-lupa]="w.last_grade == 0" [class.grade-tersangkut]="w.last_grade == 1">{{w.grade_label}}</span></td>
          <td class="text-center">{{w.stuck_ayahs || '—'}}</td>
          <td class="text-center">{{w.lupa_count ? w.lupa_count + '×' : '—'}}</td>
          <td class="text-center">{{w.review_count}}&times;</td>
          <td class="vl-muted">{{w.agoVw}}</td>
        </tr>
        </tbody>
      </table>
      </div>
      <div class="vl-empty" *ngIf="!mrj.weak.length">Tidak ada halaman lemah</div>
    </div>
  </ng-container>

  <!-- ---------- RIWAYAT SESI ---------- -->
  <div class="vl-card" *ngIf="!mrj || mrj.available">
    <div class="vl-loading" *ngIf="loading.mSessions"><img src="assets/images/preloaders/3.svg" class="vl-loading-img" alt="Memuat data"></div>
    <div class="td-subbar">
      <b class="mr-head">Riwayat Sesi</b>
    </div>
    <ul class="tl-feed">
      <li *ngFor="let s of mSessions" class="tl-feed-row">
        <span class="tl-feed-ico" [class.ok]="s.isClean" [class.warn]="!s.isClean"><i class="fa" [ngClass]="s.isClean ? 'fa-check' : 'fa-exclamation'"></i></span>
        <div class="tl-feed-body">
          <div class="tl-feed-text">Muraja'ah <b>{{s.pages_text}}</b><ng-container *ngIf="s.juzVw"> &middot; {{s.juzVw}}</ng-container></div>
          <div class="tl-feed-meta">
            <span class="vl-tag kind">{{formatNumber(s.page_count)}} halaman</span>
            <span class="vl-tag grade-lancar" *ngIf="s.lancar_count">{{s.lancar_count}} lancar</span>
            <span class="vl-tag grade-tersangkut" *ngIf="s.tersangkut_count">{{s.tersangkut_count}} tersangkut</span>
            <span class="vl-tag grade-lupa" *ngIf="s.lupa_count">{{s.lupa_count}} lupa</span>
            <span>{{s.dayVw}}<ng-container *ngIf="s.durationVw"> &middot; {{s.durationVw}}</ng-container></span>
          </div>
        </div>
        <time class="tl-feed-time" [title]="s.timeFull">{{s.timeVw}}</time>
      </li>
      <li *ngIf="!mSessions.length && !loading.mSessions" class="vl-empty">Belum ada sesi muraja'ah</li>
    </ul>
    <div class="vl-foot">
      <span class="vl-summary">Menampilkan <b>{{formatNumber(rangeFrom(mSessionsPage, mSessionsTotal))}}&ndash;{{formatNumber(rangeTo(mSessionsPage, mSessions.length))}}</b> dari <b>{{formatNumber(mSessionsTotal)}}</b> sesi</span>
      <div class="vl-spacer"></div>
      <nav class="vl-pager" aria-label="Navigasi sesi muraja'ah">
        <button type="button" class="vl-page" [disabled]="mSessionsPage == 1" (click)="goMurojaahSessionsPage(mSessionsPage - 1)">&lsaquo;</button>
        <ng-container *ngFor="let p of mSessionsPages">
          <span *ngIf="p == '...'" class="vl-ellipsis">&hellip;</span>
          <button *ngIf="p != '...'" type="button" class="vl-page" [class.active]="p == mSessionsPage" (click)="goMurojaahSessionsPage(p)">{{p}}</button>
        </ng-container>
        <button type="button" class="vl-page" [disabled]="mSessionsPage == pagesOf(mSessionsTotal)" (click)="goMurojaahSessionsPage(mSessionsPage + 1)">&rsaquo;</button>
      </nav>
    </div>
  </div>
</div>

<div class="vb-viewer" *ngIf="isViewer" (click)="closeViewer()">
  <img [src]="isViewer" alt="Foto">
  <button type="button" class="vb-viewer-close" title="Tutup" aria-label="Tutup">&times;</button>
</div>
